module.exports = __webpack_public_path__ + "media/country_flags/tm-1921f6d6.png";